import { Button } from '@capcenter/shared';
import React from 'react'
import { Component } from 'react';


type ButtonProps = {
  generateAddressArray : () => string[];
  userOnMobile : boolean;
  loading: boolean;
  url: string | null;
}
type ButtonState = {
  userOnMobile : boolean;
  loading: boolean;
}

export class PdfSaveButton extends Component<ButtonProps, ButtonState> {
  alink?: HTMLAnchorElement;
  constructor(props: any){
    super(props);
    this.alink = document.createElement("a");
  }

  render() {
    if(this.props.url && this.alink){
      this.alink = document.createElement("a");
      this.alink.download = `${this.props.generateAddressArray().join('-')}.pdf`;
      this.alink.href = this.props.url;
      this.alink.click();
      delete this.alink;
    }
    return <Button
    title={`Download Pdf for ${this.props.generateAddressArray().join(' ')}`}
    resetText
    className="font--base"
    variant="flat"
    size={this.props.userOnMobile ? 'sm' : 'md'}
    color={ 'gray'}
    disabled={this.props.loading}
    label={this.props.loading ?
      'Loading...'
      :
      this.props.userOnMobile ?
          'Save PDF'
        :
          'Download PDF'
      }
  />
  }
}
